import React from "react";
import { Link } from "react-router-dom";

interface ForgetPasswordFooterProps {
  message: string;
  linkText: string;
  linkUrl: string;
}

const ForgetPasswordFooter: React.FC<ForgetPasswordFooterProps> = ({
  message,
  linkText,
  linkUrl,
}) => {
  return (
    <div className="mt-4 text-center">
      <p className="mb-0">
        {message}{" "}
        <Link
          to={linkUrl}
          className="fw-semibold text-success text-decoration-underline"
        >
          {linkText}
        </Link>
      </p>
    </div>
  );
};

export default ForgetPasswordFooter;
